module.exports = __webpack_public_path__ + "static/img/kaoyan.dd064c5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kaoyan.jpeg
// module id = tKbi
// module chunks = 0